import {createSlice} from "@reduxjs/toolkit"
//createSlice 创建store的方法
const fontSizeStore = createSlice({
    name : 'fontSizeChange', //给模块一个名字
    initialState:{
        size: localStorage.getItem('ai-chat-setting-size') || '小'
    }, //初始化state
    reducers :{
        toSetting(state,action){
            localStorage.setItem('ai-chat-setting-size',action?.payload)
            state.size = action?.payload
        }
    }//修改状态的方法 同步方法 支持直接修改
})

const {toSetting} = fontSizeStore.actions

//获取reducer函数
const reducer = fontSizeStore.reducer
//导出创建action对象的函数和reducer函数
export {toSetting}
export default reducer
